export const backend = {
	urlEndPoint: "https://api.flashteller.com",
};
